module.exports = "/images/user-white.svg?b08e3a30a8e918ff140ec5353deb4e1f";